import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import HomePage from './pages/Home';
import FeaturesPage from './pages/Features';
import VideoLibrary from './pages/VideoLibrary';
import BlogPage from './pages/Blog/BlogPage';

import AboutPage from './pages/About';
import DemoRequestPage from './pages/DemoRequest/DemoRequestPage';
import Login from './pages/Login/Login';
import GeneralTerms from './pages/GeneralTerms/GeneralTerms';
import GeneralTerms2 from './pages/GeneralTerms/GeneralTerms2';
import GeneralTerms3 from './pages/GeneralTerms/GeneralTerms3';
import LogoAnimation from './components/ui/LogoAnimation/LogoAnimation';
import CartPage from './pages/Cart/CartPage';
import WellnessPage from './pages/Wellness/WellnessPage';
import CheckoutPage from './pages/Checkout/CheckoutPage';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import ShippingInfo from './pages/ShippingInfo/ShippingInfo';
import Returns from './pages/Returns/Returns';
import SuccessPage from './pages/Success/SuccessPage';
import NotifyMe from './pages/NotifyMe';
import Dashboard from './pages/Admin/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import Orders from './pages/Admin/Orders';
import Products from './pages/Admin/Products';
import Analytics from './pages/Admin/Analytics';
import AdminsManagement from './pages/Admin/AdminsManagement.jsx';
import RegisterAdmin from './pages/Admin/RegisterAdmin';
import AdminLayout from './pages/Admin/AdminLayout';
import AdminShipping from './pages/Admin/Shipping.jsx';
import AdminIndexRedirect from './pages/Admin/AdminIndexRedirect';

const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/features" element={<FeaturesPage />} />
        <Route path="/shop" element={<VideoLibrary />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/wellness" element={<WellnessPage />} />

        <Route path="/contact" element={<DemoRequestPage />} />
        <Route path="/general-terms/page/1" element={<GeneralTerms />} />
        <Route path="/general-terms/page/2" element={<GeneralTerms2 />} />
        <Route path="/general-terms/page/3" element={<GeneralTerms3 />} />
        <Route path="/admin/login" element={<Login />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/shipping-info" element={<ShippingInfo />} />
        <Route path="/returns" element={<Returns />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/notify-me" element={<NotifyMe />} />
        <Route path="/admin" element={<ProtectedRoute><AdminLayout><Outlet /></AdminLayout></ProtectedRoute>}>
          <Route index element={<AdminIndexRedirect />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="orders" element={<Orders />} />
          <Route path="products" element={<Products />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="admins" element={<ProtectedRoute requiredRole="superadmin"><AdminsManagement /></ProtectedRoute>} />
          <Route path="register-admin" element={<ProtectedRoute requiredRole="superadmin"><RegisterAdmin /></ProtectedRoute>} />
          <Route path="shipping" element={<ProtectedRoute><AdminShipping /></ProtectedRoute>} />
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRoutes;
